//
// Shop: Search
//

"use strict";

(function ($, waTheme) {

    var CheckMobile = (function ($) {

        CheckMobile = function (options) {
            var that = this;

            // DOM
            that.$window = $(window);

            // VARS
            that.reloading = false;

            // INIT
            that.init();

            // EVENTS
            that.bindEvents();
        };

        CheckMobile.prototype.init = function () {
            var that = this,
                is_mobile_media = MatchMedia(`(max-width: ${window.waTheme.themesettings.settings["common__common_set_mobile_type_number"]["value"]}px)`),
                is_mobile_cookie = $.cookie("is_mobile");

            // return if waIsMobile && device
            if (window.waTheme.is_mobile_checking_by_wa === "true") return;

            // console.log({
            //     reloading: that.reloading,
            //     is_mobile_media: is_mobile_media,
            //     is_mobile_cookie: is_mobile_cookie,
            // });

            if (that.reloading !== true && is_mobile_media === true && is_mobile_cookie !== "true") {
                setCookie(true, true);
            } else if (that.reloading !== true && is_mobile_media === false && is_mobile_cookie !== "false") {
                setCookie(false);
            }

            function setCookie(is_mobile, force = false) {
                $.cookie("is_mobile", is_mobile, { path: '/' });
                if (is_mobile_cookie !== undefined && is_mobile_cookie !== null || force) {
                    that.reloading = true;
                    window.location.reload();
                }
            }

            function MatchMedia(media_query) {
                var matchMedia = window.matchMedia;
                var is_supported = (typeof matchMedia === "function");

                if (is_supported && media_query) {
                    return matchMedia(media_query).matches;
                } else {
                    return false;
                }
            }
        };


        CheckMobile.prototype.bindEvents = function () {
            var that = this;

            //
            that.$window.on("resize", that.init);
        };

        return CheckMobile;

    })($);

    waTheme.init.shop.CheckMobile = CheckMobile;

    new window.waTheme.init.shop.CheckMobile({});

})(jQuery, window.waTheme);
